import axios, { AxiosInstance } from "axios";

const STORAGE_KEY = "fg_session_id";

let sessionId: string | null = null;
let sessionPromise: Promise<string> | null = null;

const createSession = async (): Promise<string> => {
  try {
    const response = await axios.post(
      `${import.meta.env.VITE_API_BASE_URL}/sessions`
    );
    const newSessionId = response.data.session_id;
    localStorage.setItem(STORAGE_KEY, newSessionId);
    return newSessionId;
  } catch (error) {
    console.error("Failed to create session:", error);
    throw error;
  }
};

const getSessionId = async (): Promise<string> => {
  if (sessionId) return sessionId;

  // If there's already a session creation in progress, wait for it
  if (sessionPromise) return sessionPromise;

  // Try to get existing session from localStorage
  const storedSession = localStorage.getItem(STORAGE_KEY);
  if (storedSession) {
    sessionId = storedSession;
    return storedSession;
  }

  // Create a new session if none exists
  sessionPromise = createSession().then((id) => {
    sessionId = id;
    sessionPromise = null;
    return id;
  });

  return sessionPromise;
};

export const createApiClient = (): AxiosInstance => {
  const api = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
  });

  api.interceptors.request.use(async (config) => {
    const id = await getSessionId();
    config.headers["x-session-id"] = id;
    return config;
  });

  return api;
};

export const api = createApiClient();
